import React from 'react';
import { ArcBox } from '@src/core/ui';
import controllerImg from '../../assets/controller.png';

const GamepadImage: React.FC = () => {
  return (
    <ArcBox
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={controllerImg}
        alt='Controller'
        style={{
          maxWidth: '100%',
          height: 'auto',
          maxHeight: 480,
          objectFit: 'contain',
        }}
      />
    </ArcBox>
  );
};

export default GamepadImage;
